import { defineComponent as v, ref as f, computed as C, createBlock as d, openBlock as a, unref as t, withCtx as r, createElementVNode as i, normalizeClass as u, createVNode as p, createTextVNode as _, toDisplayString as c, normalizeStyle as b, Teleport as h, createElementBlock as y, createCommentVNode as L, Fragment as N, renderList as B } from "vue";
import { useFloating as S, offset as E, flip as R, shift as x, autoUpdate as z } from "@floating-ui/vue";
import { Listbox as D, ListboxButton as F, ListboxOptions as O, ListboxOption as T } from "@headlessui/vue";
import { ScalarIconCaretDown as U } from "@scalar/icons";
const W = { class: "option-label" }, q = /* @__PURE__ */ v({
  __name: "HeaderListbox",
  props: {
    options: {},
    modelValue: {},
    static: { type: Boolean },
    buttonName: {},
    buttonClass: {}
  },
  emits: ["update:modelValue"],
  setup($) {
    const m = f(null), n = f(null), V = C(
      () => {
        var e, o;
        return ((o = (e = n.value) == null ? void 0 : e.children) == null ? void 0 : o[0]) || n.value;
      }
    ), { floatingStyles: g } = S(V, m, {
      placement: "bottom-start",
      whileElementsMounted: z,
      middleware: [E(5), R(), x()]
    });
    return (e, o) => (a(), d(t(D), {
      as: "div",
      modelValue: e.modelValue,
      "onUpdate:modelValue": o[0] || (o[0] = (l) => e.$emit("update:modelValue", l))
    }, {
      default: r(({ open: l }) => [
        i("div", {
          ref_key: "buttonWrapper",
          ref: n,
          class: u({
            "button-wrapper": !!e.$slots.default
          })
        }, [
          p(t(F), {
            as: "button",
            class: u(["header-item-link header-group-link", e.buttonClass])
          }, {
            default: r(() => [
              _(c(e.buttonName) + " ", 1),
              p(t(U), {
                style: b({
                  transform: l ? "rotate(180deg)" : "rotate(0deg)"
                })
              }, null, 8, ["style"])
            ]),
            _: 2
          }, 1032, ["class"])
        ], 2),
        (a(), d(h, {
          disabled: e.static,
          to: "#app"
        }, [
          l ? (a(), y("div", {
            key: 0,
            ref_key: "dropdownRef",
            ref: m,
            class: "floating",
            style: b(t(g))
          }, [
            p(t(O), {
              class: "dropdown",
              static: ""
            }, {
              default: r(() => [
                (a(!0), y(N, null, B(e.options, (s) => (a(), d(t(T), {
                  key: s.id,
                  as: "template",
                  disabled: s.disabled,
                  value: s
                }, {
                  default: r(({ active: k, selected: w }) => [
                    i("li", {
                      class: u(["option", { active: k, selected: w }])
                    }, [
                      i("span", W, c(s.label), 1)
                    ], 2)
                  ]),
                  _: 2
                }, 1032, ["disabled", "value"]))), 128))
              ]),
              _: 1
            })
          ], 4)) : L("", !0)
        ], 8, ["disabled"]))
      ]),
      _: 1
    }, 8, ["modelValue"]));
  }
});
export {
  q as default
};
